import React from 'react';
import { formatMinBet, formatRtp } from '../utils/format';

const positive = (v) => parseFloat(v) > 0;

/**
 * Game card / details stats:
 *   Min Bet | Max Bet     (one row, two columns)
 *   RTP                   (own row)
 * Any value that is 0 or missing is left out; nothing renders if all are.
 */
export default function GameStats({ game }) {
  const showMin = positive(game.min_bet);
  const showMax = positive(game.max_bet);
  const showRtp = positive(game.rtp);
  if (!showMin && !showMax && !showRtp) return null;

  return (
    <div className="game-stats">
      {(showMin || showMax) && (
        <div className={`game-stats-row${showMin && showMax ? ' game-stats-row--pair' : ''}`}>
          {showMin && (
            <span className="stat"><span className="stat-label">Min bet</span>{formatMinBet(game.min_bet, game.default_currency)}</span>
          )}
          {showMax && (
            <span className="stat"><span className="stat-label">Max bet</span>{formatMinBet(game.max_bet, game.default_currency)}</span>
          )}
        </div>
      )}
      {showRtp && (
        <div className="game-stats-row">
          <span className="stat"><span className="stat-label">RTP</span>{formatRtp(game.rtp)}</span>
        </div>
      )}
    </div>
  );
}
